import { Alert, AlertIcon, AlertDescription } from '@chakra-ui/react';

export const FailedToLoad = () => (
  <Alert status="warning">
    <AlertIcon />
    <AlertDescription>Failed to load payment component.</AlertDescription>
  </Alert>
);
